import { WarningFilled } from '@ant-design/icons';
import { BaseAlertBanner } from '@components';
import { AbsoluteWrapper as Wrapper } from '@components/alert-banner/styled.tsx';
import { useLingui } from '@lingui/react/macro';

const EditModeAlertBanner = () => {
    const { t } = useLingui();
    const TITLE = t`You are now in edit mode`;
    const DESCRIPTION = t`Changes are not saved until submitted. Some fields are restricted and require admin approval. Don’t forget to submit for review.`;

    return (
        <Wrapper $width={'35%'}>
            <BaseAlertBanner closable type="warning" title={TITLE} description={DESCRIPTION} icon={<WarningFilled />} />
        </Wrapper>
    );
};

export default EditModeAlertBanner;
